import CheckBox from '../CheckBox/CheckBox'
import styles from './CheckBoxGroup.module.scss'

type CheckBoxType = {
  selected: boolean
  label: string
}

interface CheckBoxGroupProps {
  checkBoxes: CheckBoxType[]
  onChange?: (index: number, value: boolean) => void
  field: {
    onChange: (value: boolean[]) => void
    onBlur: () => void
    value: boolean[]
    name: string
  }
  disabled?: boolean
}

function CheckBoxGroup(props: CheckBoxGroupProps) {
  const { checkBoxes, field, disabled, onChange } = props
  const value = Array.isArray(field.value)
    ? field.value
    : new Array(checkBoxes.length).fill(false)

  const handleToggle = (index: number, checked: boolean) => {
    if (field.onChange) {
      const next = [...value]
      next[index] = checked
      field.onChange(next)
    } else if (onChange) {
      onChange(index, checked)
    }
  }

  return (
    <div className={styles.checkBoxGroupWrapper} onBlur={field.onBlur}>
      {checkBoxes.map((checkBox, index) => (
        <CheckBox
          key={`${field.name}-${checkBox.label}`}
          label={checkBox.label}
          checked={!!value[index]}
          disabled={disabled}
          onChange={(checked: boolean) => handleToggle(index, checked)}
        />
      ))}
    </div>
  )
}

export default CheckBoxGroup
